import axiosClient from "../common/axios/axiosConfig";
import { showToast } from "../utils/showToast";

export interface IProfessionalCertificate {
	conselhoProfissional: string;
	conselhoNumeroProfissional: string;
	conselhoEstadoProfissional: string;
}

export interface IScheduleInfo {
	inicio: string;
	fim: string;
	duracao: number;
	profissional: string;
	procedimento: {
		_id: string;
		description: string;
	};
	idProcedimento: string;
	certificadoProfissional: IProfessionalCertificate;
	linkTelemedicine: string;
}

export const getBuscarAgendamento = (idAgendamento: string): Promise<IScheduleInfo> => {
	return axiosClient
		.get(`/buscar-agendamento/${idAgendamento}`)
		.then(response => {
			return response.data;
		})
		.catch(() => {
			showToast("error", {
				text: "Erro ao buscar informações do agendamento",
				timerProgressBar: true,
			});
			return {} as IScheduleInfo;
		});
};
